import VehiclesGeneralInfo from "./VehiclesGeneralInfo";

export default VehiclesGeneralInfo;
